'use client';

import { useCallback } from 'react';
import { withLangPrefix } from '../i18n/locale';
import { useRuntime } from '../runtime/RuntimeContext';
import { useLanguage } from '../stores/languageStore';

export function useLocalizedHref(): (href: string) => string {
  const runtime = useRuntime();
  const language = useLanguage();
  return useCallback(
    (href: string) => (runtime === 'web' ? withLangPrefix(language, href) : href),
    [runtime, language],
  );
}
